import LeanNavbar from "./components/LeanNavbar";
import LeanHero from "./components/LeanHero";
import LeanPains from "./components/LeanPains";
import LeanVision from "./components/LeanVision";
import LeanMethodology from "./components/LeanMethodology";
import LeanPricing from "./components/LeanPricing";
import LeanPhilosophy from "./components/LeanPhilosophy";
import LeanContact from "./components/LeanContact";
import LeanFooter from "./components/LeanFooter";
import SeoHead from "@/components/feature/SeoHead";
import { lean } from "@/content";

/**
 * Lean-консалтинг. Один адрес — две темы.
 */
export default function LeanPage() {

  return (
    <>
      <SeoHead
        title={lean.seo.title}
        description={lean.seo.description}
        keywords={lean.seo.keywords}
        canonicalPath={lean.seo.canonicalPath}
      />
              <div className="min-h-screen font-sans bg-[#FAFAF8] dark:bg-[#0A0A0A]">
          <LeanNavbar />
          <main>
            <LeanHero />
            <LeanPains />
            <LeanVision />
            <LeanMethodology />
            <LeanPricing />
            <LeanPhilosophy />
            <LeanContact />
          </main>
          <LeanFooter />
        </div>
    </>
  );
}
